import React, { Component } from 'react';
import './OrgCertificates.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Table, Button } from 'reactstrap';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import IconContainer from "../../../commonComponents/iconContainer/IconContainer";
import AddOrgCertificateModal from '../addCertificateModal/AddOrgCertificateModal.container';
import RemoveOrgCertificateModal from '../removeCertificateModal/RemoveOrgCertificateModal.container';
import moment from 'moment';

class OrgCertificates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            certId: null
        };
    };

    componentWillMount() {
        this.props.onGetOrgCertificates(this.props.orgId);
    }

    render() {
        if (this.props.fetching) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
        }

        if (this.props.permissions && !this.props.permissions.hasIVs && !this.props.permissions.providesMoocCertificates) {
            return (
                <h6 className="text-center">{_.get(this.props.translation, 'certificate.no_certificates_needed_label')}</h6>
            )
        }

        if (!_.isNil(this.props.certificates)) {
            if (this.props.certificates.length === 0) {
                return (
                    <h6 className="text-center">
                        {_.get(this.props.translation, "certificate.no_org_certificate_label_start")}
                        <a href="/security">
                            {_.get(this.props.translation, "certificate.no_org_certificate_label_link")}
                        </a>
                        {_.get(this.props.translation, "certificate.no_org_certificate_label_end")}
                    </h6>
                )
            } else {
                return (
                    <div className='org-certificates-container'>
                        {this.renderCertificates()}
                        <div className="add-org-certificate-button-container">
                            <Button className="olive-green-btn" onClick={this.props.onAddCertificate}>
                                {_.get(this.props.translation, sharedLabelsPath.add_button)}
                            </Button>
                        </div>
                        <AddOrgCertificateModal orgId={this.props.orgId} />
                        <RemoveOrgCertificateModal certId={this.state.certId} orgId={this.props.orgId} />
                    </div>
                );
            }
        } else {
            return null;
        }
    }

    renderCertificates = () => {
        return (
            <Table className='org-certificates-list-table'>
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, 'certificate.created_at_label')}</th>
                        <th>{_.get(this.props.translation, 'certificate.valid_from_label')}</th>
                        <th>{_.get(this.props.translation, 'certificate.valid_till_label')}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {this.renderCertificatesData()}
                </tbody>
            </Table>
        );
    };

    renderCertificatesData = () => {
        return _.map(this.props.certificates, (certificateData, index) => (
            <tr key={index} >
                <td
                    className='org-certificate-created-at-td'
                    data-th={_.get(this.props.translation, 'certificate.valid_till_label') + ":"}
                >
                    {moment(certificateData.createdAt).format("MMMM Do YYYY, HH:mm")}
                </td>
                <td
                    className='org-certificate-valid-from-td'
                    data-th={_.get(this.props.translation, 'certificate.valid_from_label') + ":"}
                >
                    {moment(certificateData.validFrom).format("MMMM Do YYYY, HH:mm")}
                </td>
                <td
                    className='org-certificate-valid-till-td'
                    data-th={_.get(this.props.translation, 'certificate.valid_till_label') + ":"}
                >
                    {moment(certificateData.validTill).format("MMMM Do YYYY, HH:mm")}
                </td>
                <td className='org-certificate-remove-icon-td'>
                    <IconContainer
                        key={index}
                        icon='trash'
                        className='org-certificate-remove-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                        onClick={this.onRemoveCertificate(certificateData.id)}
                    />
                </td>
            </tr>
        ));
    };

    onRemoveCertificate = (certId) => () => {
        this.setState({ certId: certId });
        this.props.onRemoveCertificate();
    }
}

OrgCertificates.propTypes = {
    orgId: PropTypes.string.isRequired,
    certificates: PropTypes.array,
    translation: PropTypes.object.isRequired,
    onGetOrgCertificates: PropTypes.func.isRequired,
    onAddCertificate: PropTypes.func.isRequired,
    onRemoveCertificate: PropTypes.func.isRequired
};

export default OrgCertificates;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/certificatesManagement/orgCertificates/OrgCertificates.js